import React, { useEffect, useState } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Button,
    Form,
    FormGroup,
    Label,
    Input,
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from "reactstrap";
import Select from "react-select";
import { useFormik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import TableContainer from "../../../../components/Common/TableContainer";
import { FaSearch, FaSyncAlt, FaFileExport, FaSave } from "react-icons/fa";
import CustomMonthPicker from "common/CustomMonthPicker";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchCategories, fetchCategoryMapping, fetchCategoriesMappinglist, createCategorymappingRequest } from "store/actions";
import CustomSelect from "components/Common/custom-select";
import Loader from "../../../../common/pageLoader";
import { Link } from "@mui/material";
import useButtonAccess from "components/Common/useButtonAccess";
import Swal from "sweetalert2";

const CategoryMapping = () => {
    const dispatch = useDispatch();
    const [authDetails, setAuthDetails] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const {
        categories,
        categoryMapping,
        mapList,
        loading,
        success,
        error,
    } = useSelector((state) => ({
        categories: state.CategoryMaster?.categories ?? [],
        categoryMapping: state.categoryMappingReducer?.categoryMapping ?? [],
        mapList: state.categoryMappingReducer?.mapList ?? [],
        loading: state.CategoryMaster?.loading || state.categoryMappingReducer?.loading,
        error: state.CategoryMaster?.error || state.categoryMappingReducer?.error,
        success: state.CategoryMaster?.success || state.categoryMappingReducer?.success
    }));

    useEffect(() => {
        const authUserDetails = useAuthUserDetails();
        setAuthDetails(authUserDetails[0]);
        dispatch(fetchCategories(authUserDetails[0]?.unit_id));
    }, [dispatch]);

    useEffect(() => {
        if (success === true || authDetails) {
            formik.resetForm();
            setTableData([]);

            const formData = new FormData();
            formData.append("unit_id", authDetails?.unit_id);
            formData.append("create_by", authDetails?.user_id);

            dispatch(fetchCategoriesMappinglist(formData));
        }
    }, [success, authDetails, dispatch]);

    const formik = useFormik({
        initialValues: {
            category: "",
            fromDate: "",
            rows: tableData,
        },
        validationSchema: Yup.object({
            category: Yup.string().required("Please Select Category"),
            fromDate: Yup.string().required("Date is required"),
            rows: Yup.array().of(Yup.object().shape({
                component_percentage: Yup.number().when("is_mapped", { is: 0, then: Yup.number().typeError("Percentage must be a number").required("Percentage is required").min(0, "Minimum is 0"), otherwise: Yup.number().notRequired() })
            })
            )
        }),
        onSubmit: (values) => {
            const selectedRows = tableData.filter(row => row.is_mapped === 1);

            if (selectedRows.length === 0) {
                Swal.fire({
                    icon: "error",
                    title: "Validation Error",
                    text: "Please select at least one Map checkbox",
                    confirmButtonColor: "#d33",
                });
                return;
            }

            const totalPercentage = selectedRows.reduce((sum, row) => sum + Number(row.component_percentage || 0), 0);
            if (totalPercentage > 100 || totalPercentage < 100) {
                Swal.fire({
                    icon: "error",
                    title: "Invalid Percentage",
                    text: "Total percentage should be 100",
                    confirmButtonColor: "#d33",
                });
                return;
            }

            const comArray = selectedRows.map(row => ({
                cat_map_id: row.cat_map_id ? row.cat_map_id.toString() : "0",
                pay_allownance_id: row.pay_allownance_id?.toString(),
                is_pf: row.is_pf ? "1" : "0",
                is_esi: row.is_esi ? "1" : "0",
                is_extrahours: row.is_extrahours ? "1" : "0",
                component_percentage: row.component_percentage ? Number(row.component_percentage).toFixed(2) : "0",
                is_mapped: row.is_mapped ? "1" : "0"
            }));

            const formData = new FormData();
            formData.append("param", JSON.stringify({ com: comArray }));
            formData.append("cat_id", values.category);
            formData.append('fromdate', values.fromDate);
            formData.append("create_by", authDetails?.user_id?.toString());

            dispatch(createCategorymappingRequest(formData))
        }
    });

    useEffect(() => {
        if (categoryMapping?.length > 0) {
            //auto select for is_mapped
            const updatedData = categoryMapping.map(row => ({
                ...row, is_mapped: (row.is_pf === 1 || row.is_esi === 1) ? 1 : row.is_mapped
            }));
            setTableData(updatedData);
            formik.setFieldValue("rows", updatedData);
            //old code is_mapped not seleted
            // setTableData(categoryMapping);
            // formik.setFieldValue("rows", categoryMapping);
            // setIsEdit(true);
        } else {
            setTableData([]);
            // setIsEdit(false);
        }
    }, [categoryMapping]);

    // const handleTableChange = (index, field, value) => {
    //     setTableData(prev => {
    //         const updated = [...prev];
    //         let updatedRow = {
    //             ...updated[index],
    //             [field]: value
    //         };
    //         if ((field === "is_pf" || field === "is_esi") && value === 1) {
    //             updatedRow.is_mapped = 1;
    //         }
    //         updated[index] = updatedRow;
    //         return updated;
    //     });
    // };

    const handleTableChange = (index, field, value) => {
        setTableData(prev => {
            const updated = [...prev];
            let updatedRow = {
                ...updated[index],
                [field]: value
            };
            if (field === "is_pf" || field === "is_esi") {
                const pf = field === "is_pf" ? value : updatedRow.is_pf;
                const esi = field === "is_esi" ? value : updatedRow.is_esi;
                if (pf === 1 || esi === 1) {
                    updatedRow.is_mapped = 1;
                } else {
                    updatedRow.is_mapped = 0;
                }
            }
            updated[index] = updatedRow;
            return updated;
        });
    };

    const PercentageInput = ({ index, value, onChange, error, disabled }) => {
        const [inputValue, setInputValue] = useState(value || "");

        useEffect(() => {
            setInputValue(value || "");
        }, [value]);
        const handleChange = (e) => {
            let val = e.target.value.replace(/\D/g, "");
            if (val.length > 3) val = val.slice(0, 3);
            setInputValue(val);
        };
        const handleBlur = () => {
            let finalVal = Number(inputValue);
            if (finalVal > 100) finalVal = 100;
            onChange(index, "component_percentage", finalVal.toString());
            setInputValue(finalVal.toString());
        };

        return (
            <>
                <Input type="text" inputMode="numeric" maxLength={3} value={inputValue}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={disabled}
                    className={error ? "is-invalid" : ""}
                    style={{ width: "120px" }}
                />
                {error && <div className="text-danger small">{error}</div>}
            </>
        );
    };

    const savedColumns = [
        { Header: "S#", Cell: ({ row }) => { return mapList.length - row.index; }, className: "serial-no text-center", },
        { Header: "CATEGORY", accessor: "emp_category", },
        { Header: "PERCENTAGE", accessor: "component_percentage", },
        { Header: "ALLOWANCE_MAPPED", accessor: "pay_allowance", },
        { Header: "EFFECT_DATE", accessor: "effective_dt", },
        { Header: "CREATED_BY", accessor: "created_by", },
        { Header: "CREATED_DATE", accessor: "created_date", },
    ];

    const totalPercentage = tableData.reduce((sum, row) => sum + Number(row.component_percentage || 0), 0);
    const hasHundred = tableData.some(row => Number(row.component_percentage) === 100);

    const isRowDisabled = (index) => {
        const row = tableData[index];
        const hasPercentage = Number(row?.component_percentage || 0) > 0;
        if (totalPercentage >= 100 && !hasPercentage) {
            return true;
        }
        return false;
    };

    const isPercentageDisabled = (index) => {
        const row = tableData[index];
        if (hasHundred && Number(row?.component_percentage) !== 100) {
            return true;
        }
        return false;
    };

    const columns = [
        { Header: "Component", accessor: "component_name", },
        {
            Header: "PF", accessor: "is_pf",
            Cell: ({ row }) => (
                <Input type="checkbox" disabled={isRowDisabled(row.index)} checked={tableData[row.index]?.is_pf === 1}
                    onChange={(e) => handleTableChange(row.index, "is_pf", e.target.checked ? 1 : 0)}
                />
            ),
        },
        {
            Header: "ESI", accessor: "is_esi",
            Cell: ({ row }) => (
                <Input type="checkbox" disabled={isRowDisabled(row.index)} checked={tableData[row.index]?.is_esi === 1}
                    onChange={(e) => handleTableChange(row.index, "is_esi", e.target.checked ? 1 : 0)}
                />
            ),
        },
        {
            Header: "Extra Hours", accessor: "is_extrahours",
            Cell: ({ row }) => (
                <Input type="checkbox" disabled={isRowDisabled(row.index)} checked={tableData[row.index]?.is_extrahours === 1}
                    onChange={(e) => handleTableChange(row.index, "is_extrahours", e.target.checked ? 1 : 0)}
                />
            ),
        },
        {
            Header: (<> Percentage <span className="text-danger">*</span></>),
            accessor: "component_percentage",
            Cell: ({ row }) => {
                const index = row.index;
                const error = formik.touched.rows?.[index]?.component_percentage && formik.errors.rows?.[index]?.component_percentage;
                return (
                    <PercentageInput index={index} value={tableData[index]?.component_percentage} onChange={handleTableChange} error={error} disabled={isPercentageDisabled(index)} />
                );
            }
        },
        {
            Header: "is_mapped", accessor: "is_mapped",
            Cell: ({ row }) => (
                <Input type="checkbox" disabled={isRowDisabled(row.index)} checked={tableData[row.index]?.is_mapped === 1}
                    onChange={(e) => handleTableChange(row.index, "is_mapped", e.target.checked ? 1 : 0)}
                />
            ),
        },
    ];

    const handleCancel = () => {
        formik.resetForm();
        setIsEdit(false);
        setTableData([]); setIsEdit(false);
    };

    return (
        <div className="page-content">
            <Loader loading={loading} />
            <Container fluid>
                <Breadcrumbs title="Payroll / Setup" breadcrumbItem="Salary Component Mapping" />
                <Card>
                    <CardBody>
                        <Form onSubmit={formik.handleSubmit}>
                            <Row>
                                <Col md={3} sm={12} className="mb-3">
                                    <FormGroup>
                                        <Label for="category">Category</Label>
                                        <CustomSelect
                                            id="category"
                                            name="category"
                                            options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory, }))}
                                            value={
                                                categories
                                                    .map(cat => ({
                                                        value: cat.empCatgryid.toString(),
                                                        label: cat.empCategory,
                                                    })).find(opt => opt.value === formik.values.category) || null
                                            }
                                            // onChange={(selectedOption) => {
                                            //     const categoryId = selectedOption?.value || "";
                                            //     formik.setFieldValue("category", categoryId);

                                            //     if (!categoryId) { setTableData([]); return; }
                                            //     if (authDetails) {
                                            //         dispatch(fetchCategoryMapping(categoryId, authDetails.unit_id));
                                            //     }
                                            // }}

                                            onChange={(selectedOption) => {
                                                const categoryId = selectedOption?.value || "";
                                                const categoryLabel = selectedOption?.label || "";
                                                formik.setFieldValue("category", categoryId);
                                                if (!categoryId) {
                                                    setTableData([]);
                                                    setIsEdit(false);
                                                    return;
                                                }
                                                // check if category exists in grid
                                                const exists = mapList.some(
                                                    item => item.emp_category?.trim().toLowerCase() == categoryLabel.trim().toLowerCase()
                                                );
                                                setIsEdit(exists);
                                                if (authDetails) {
                                                    dispatch(fetchCategoryMapping(categoryId, authDetails.unit_id));
                                                }
                                            }}
                                        />
                                        {formik.touched.category && formik.errors.category && (
                                            <div className="text-danger">{formik.errors.category}</div>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="fromDate">Month <span className="text-danger">*</span></Label>
                                        <CustomMonthPicker
                                            name="fromDate"
                                            value={formik.values.fromDate}
                                            onChange={(date) => formik.setFieldValue("fromDate", date)}
                                            onBlur={formik.handleBlur}
                                            className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                                        />
                                        {formik.touched.fromDate && formik.errors.fromDate && (
                                            <div className="text-danger">{formik.errors.fromDate}</div>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col className="d-flex mob-center align-items-center justify-content-end mt-2">
                                    {/* <Button type="submit" className="btn button-search me-2"><i className="fas fa-save me-1" /> Save</Button> */}
                                    <Button type="submit" className="btn button-search me-2"><i className="fas fa-save me-1" /> {isEdit ? "Update" : "Save"}</Button>
                                    <Button type="button" className="btn button-cancel me-2"
                                        onClick={() => {
                                            Swal.fire({
                                                title: "Are you sure?", text: "Unsaved clear will be lost!", icon: "warning",
                                                showCancelButton: true, confirmButtonText: "Yes, Clear", cancelButtonText: "No", confirmButtonColor: "#3085d6", cancelButtonColor: "#d33"
                                            }).then((result) => { if (result.isConfirmed) { handleCancel(); } });
                                        }}
                                    //  onClick={() => { formik.resetForm(); setTableData([]); setIsEdit(false); }} 
                                    ><i className="fas fa-sync me-1" /> CANCEL</Button>
                                </Col>
                            </Row>
                        </Form>
                    </CardBody>
                </Card>
                {tableData?.length > 0 && (
                    <Card className="mt-3">
                        <CardBody>
                            <TableContainer columns={columns} data={tableData} isPagination={false} isAddOptions={false} customPageSize={10} isGlobalFilter={true} />
                        </CardBody>
                    </Card>
                )}

                {mapList.length > 0 && (
                    <Card className="mt-3">
                        <CardBody>
                            <TableContainer columns={savedColumns} data={[...mapList].reverse()} isPagination={false} isAddOptions={false} customPageSize={10} isGlobalFilter={true} />
                        </CardBody>
                    </Card>
                )}
            </Container>
        </div>
    );
}

export default CategoryMapping;